import requestPasswordResetEmailQuery from '~layers/app/graphql/account/requestPasswordResetEmail.gql'
import resetPasswordQuery from '~layers/app/graphql/account/resetPassword.gql'

export function useAccountResetPassword() {
  const { t } = useI18n()
  const { show: showNotification } = useNotification()

  const {
    mutate: requestPasswordResetEmailMutation,
    loading: requestPasswordResetEmailLoading,
    called: requestPasswordResetEmailCalled,
    error: requestPasswordResetEmailError,
  } = useMutation(
    requestPasswordResetEmailQuery,
    { clientId: 'customer' },
  )

  const requestPasswordResetEmail = async ({ email }: { email: string }) => {
    let success = false
    try {
      const result = await requestPasswordResetEmailMutation({ email })
      success = result?.data.requestPasswordResetEmail
    }
    catch (requestPasswordResetEmailException: any) {
      showNotification({
        type: 'error',
        message: t('Something went wrong. Please try again later.'),
      })
      console.error(requestPasswordResetEmailException.message)
    }
    showNotification({
      type: 'success',
      message: t('If an account is found, you will receive an e-mail with further instructions.'),
    })
    return success
  }

  const {
    mutate: resetPasswordMutation,
    loading: resetPasswordLoading,
    called: resetPasswordCalled,
    error: resetPasswordError,
  } = useMutation(
    resetPasswordQuery,
    { clientId: 'customer' },
  )

  const resetPassword = async ({ email, resetPasswordToken, newPassword }: { email: string, resetPasswordToken: string, newPassword: string }) => {
    try {
      const result = await resetPasswordMutation({ email, resetPasswordToken, newPassword })

      showNotification({
        type: 'success',
        message: t('Your password has been reset'),
      })

      return result?.data.resetPassword
    }
    catch (resetPasswordException: any) {
      console.error('resetPasswordException', resetPasswordException)

      showNotification({
        type: 'error',
        message: t(resetPasswordException),
      })
    }
  }

  return {
    requestPasswordResetEmail,
    requestPasswordResetEmailCalled,
    requestPasswordResetEmailError,
    requestPasswordResetEmailLoading,
    resetPassword,
    resetPasswordCalled,
    resetPasswordError,
    resetPasswordLoading,
  }
}
